import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { AppointmentRescheduleReason, AppointmentStatus, Route, RouteParameters, TechSetupFailureReason } from '../../../constants'
import { FormAnalyticsProvider, useAppointment, useKeyBindings } from '../../../hooks'
import { AppointmentRescheduleFormData } from '../../../types'
import { hydratePathname } from '../../../util'
import { Card } from '../../Card'
import { MutableAppointmentStatus, ImmutableAppointment, mutableAppointmentStatuses } from '../ImmutableAppointment'
import { appointmentToRedirectPathname } from '../util'
import { Form } from './Form'

const defaultValues: AppointmentRescheduleFormData = {
  description: '',
  reason: '' as AppointmentRescheduleReason,
  techSetupFailReason: '' as TechSetupFailureReason,
}

const Reschedule = () => {
  const navigate = useNavigate()
  const { appointment, isLoading } = useAppointment()

  const redirectToCancellation = useCallback(() => {
    const pathname = hydratePathname(Route.APPOINTMENT_CANCELLATION, {
      [RouteParameters.COUNTRY]: appointment?.country,
      [RouteParameters.APPOINTMENT_ID]: appointment?.id as string,
    })

    navigate(pathname)
  }, [appointment?.id, appointment?.country, navigate])

  useKeyBindings({
    'c a n': redirectToCancellation,
  })

  useEffect(() => {
    if (!appointment) return

    const redirectPathname = appointmentToRedirectPathname(appointment, [AppointmentStatus.RESCHEDULED])

    if (redirectPathname) {
      navigate(redirectPathname)
    }
  }, [appointment])

  if (isLoading) {
    return null
  }

  const isMutableAppointment = mutableAppointmentStatuses.has(appointment?.status?.status as MutableAppointmentStatus)

  return isMutableAppointment ? (
    <FormAnalyticsProvider<AppointmentRescheduleFormData>>
      <Card>
        <Form defaultValues={defaultValues} />
      </Card>
    </FormAnalyticsProvider>
  ) : (
    <ImmutableAppointment />
  )
}

export { Reschedule }
